"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsubscribeToPodConnectionInfo = exports.subscribeToPodConnectionInfo = void 0;
var DeviceCharacteristic_1 = require("../../../common/DeviceCharacteristic");
var dataViewParsers_1 = require("../parsers/dataViewParsers");
var subscribeToPodConnectionInfo = function (device, listener) {
    return device.startNotifications(device.profile.VAPING.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.VapingCharacteristics.POD_INFORMATION; }).uuid, function (e) { return listener((0, dataViewParsers_1.parsePodInformation)(e.target.value)); });
};
exports.subscribeToPodConnectionInfo = subscribeToPodConnectionInfo;
var unsubscribeToPodConnectionInfo = function (device) {
    return device.stopNotifications(device.profile.VAPING.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.VapingCharacteristics.POD_INFORMATION; }).uuid);
};
exports.unsubscribeToPodConnectionInfo = unsubscribeToPodConnectionInfo;
